import { request } from '../../../common/request';
import { userModel } from '@entities/user';
import { getUserDocumentsResponse } from '@features/Registration';

const PATH = `${process.env.REACT_APP_API_URL}/core-service/api`;

export interface CreateAppealRequest {
  details: string;
  documents?: string;
  type: 'OPERATOR_MISTAKE' | 'PERSONAL_PARAMETER_CHANGE' | '';
  user_request_id: number;
}

export const createAppeal = async (
  createAppealRequest: CreateAppealRequest
): Promise<number | null> => {
  try {
    const response = await request.post<any>({
      url: `${PATH}/appeal/create-appeal`,
      data: { ...createAppealRequest },
    });
    const status = response?.status;
    if (typeof status === 'number' && status >= 200 && status < 300) {
      return status;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const getUserRequestId = async (): Promise<{
  id: number;
  request_number: number;
  denied_reason: string;
  request_status: string;
}> => {
  return await request
    .get({
      url: `${PATH}/user-request`,
    })
    .then((data) => data.data)
    .catch((err) => {
      return null;
    });
};

export const getMyRequestsApi = async (): Promise<
  {
    id: number;
    request_number: number;
    request_status: string;
    denied_reason?: string;
    created_at?: string;
    publish_state?: number;
  }[]
> => {
  return await request
    .get({
      url: `${PATH}/user-request/my-requests`,
    })
    .then((data) => data.data || [])
    .catch(() => []);
};

/**
 * Api GET request for getting User information
 * @returns {void}
 */
export const getUserDocumentsApi = async () => {
  const { data } = await request.get<getUserDocumentsResponse>({
    url: `${PATH}/step-4/documents`,
  });
  return data;
};

export const getInvalidDocumentsApi = async () => {
  const { data } = await request.get<getUserDocumentsResponse>({
    url: `${PATH}/step-4/get-all-invalid-documents`,
  });
  return data;
};

export const getUserAppealDocumentsApi = async (requestId: number) => {
  const { data } = await request.get<getUserDocumentsResponse>({
    url: `${PATH}/appeal/get-appeal-documents/${requestId}`,
  });
  return data;
};

export const getUserRequestDataApi = async () => {
  const { data } = await request.get<any>({
    url: `${PATH}/user-request-details/get-user-request-by-user-id`,
  });
  return data;
};

export const getUserRequestScoreApi = async (requestId: number) => {
  const { data } = await request.get<any>({
    url: `${PATH}/score/get-detailed-user-score/${requestId}`,
  });
  return data;
};

export const getUserAppealApi = async (requestId: number) => {
  const { data } = await request.get<any>({
    url: `${PATH}/appeal/by-user-request/${requestId}`,
  });
  return data;
};

export const updateAppealApi = async (
  requestId: number,
  docs: Partial<CreateAppealRequest>
) => {
  const { data } = await request.patch<any>({
    url: `${PATH}/appeal/update-appeal/by-user/${requestId}`,
    data: docs,
  });
  return data;
};

export const returnBankFromFixApi = async (id: string) => {
  const { data } = await request.patch<getUserDocumentsResponse>({
    url: `${PATH}/approval-mahat/change_user_request_status_to_invalid_bank_fixed/${id}`,
  });
  return data;
};

type Props = {
  bank_name: string;
  branch_number: string;
  account_number: string;
  bank_account_reference: string;
};
export const fixBankDetailsApi = async (requestId: number, props: Props) => {
  const { data } = await request.patch<getUserDocumentsResponse>({
    url: `${PATH}/user-request/fix-bank-details/${requestId}`,
    data: props,
  });
  return data;
};

export const returnAppealFromCorrectionApi = async (
  requestId: number,
  props: Record<string, any>
) => {
  const { data } = await request.post<getUserDocumentsResponse>({
    url: `${PATH}/appeal/submit-corrections/${requestId}`,
    data: props,
  });
  return data;
};

export const getPdfApi = async (): Promise<any> => {
  const response = await request.get<any>({
    url: `${PATH}/publish/get-result-pdf`,
    config: {
      responseType: 'arraybuffer',
    },
  });
  return response.data;
};
